import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { String } from 'typescript-string-operations';
import { RootService } from './root.service';

@Injectable({
  providedIn: 'root'
})
export class ProblemsService {

  readonly BaseURI: string = '';

  constructor(private http: HttpClient, private rootService: RootService) {
    this.BaseURI = this.rootService.GetBaseURL();
  }

  getProblemList(){
     return this.http.get(this.BaseURI + '/CSP/get-all-problems').pipe(map(res => res));
  }

  getProblemsByProductId(productId){
    return this.http.get<any>(String.Format(this.BaseURI + '/CSP/get-problems/{0}', productId)).pipe(map( res => <any>res));
  }

}
